import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: () => ({
    whitelist: {}, // 使用对象存储主账户和子账户的映射关系
    currentMaster: '', // 当前选中的主账户
    editItem: null,
    masterOrder: [] // 新增：用于维护主账号显示顺序
  }),
  mutations: {
    setWhitelist(state, payload) {
      state.whitelist = payload || {};
    },
    setCurrentMaster(state, payload) {
      state.currentMaster = payload;
    },
    setEditItem(state, payload) {
      state.editItem = payload;
    },
    setMasterOrder(state, payload) { // 新增
      state.masterOrder = payload;
    }
  },
  actions: {
    async fetchWhitelist({ commit }) {
      const res = await api.getWhitelist();
      const data = res.data;
      if (data && data.length > 0) {
        const parsed = JSON.parse(data[0].confValue);
        const order = Object.keys(parsed);
        commit('setWhitelist', parsed);
        commit('setMasterOrder', order);
      } else {
        commit('setWhitelist', {});
        commit('setMasterOrder', []);
      }
    },

    async updateList({ state, commit }, newList) {
      const updatedWhitelist = { ...state.whitelist };
      if (state.currentMaster) {
        updatedWhitelist[state.currentMaster] = newList;
      }
      await api.updateWhitelist(updatedWhitelist);
      commit('setWhitelist', updatedWhitelist);
    },

    async updateMasterList({ state, commit }, { oldKey, newKey, subs }) {
      const newData = {};
      if (newKey && newKey.trim() !== '' && newKey.trim() !== 'null' && newKey.trim() !== 'undefined') {
        newData[newKey] = subs || [];
      }
      for (const key in state.whitelist) {
        if (key !== oldKey && key !== newKey) {
          newData[key] = state.whitelist[key];
        }
      }

      const newOrder = [];
      if (newKey) {
        newOrder.push(newKey);
      }
      Object.keys(newData).forEach(key => {
        if (key !== oldKey && !newOrder.includes(key)) {
          newOrder.push(key);
        }
      });
      commit('setMasterOrder', newOrder);

      return api.updateWhitelist(newData);
    }
  }
};

appStore.registerModule('transferApprovalWhitelist', store);
